import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser, setForms, setFormThemes, setTags } from "../redux/features/appData";
import { User, Form } from "effno-core";
import { useDispatch } from "react-redux";
import { apiGetEditableFormsForWorkspace } from "../services/FormService";
import { apiGetTagsForWorkspace } from "../services/TagService";
import { apiGetFormThemesForWorkspace } from "../services/FormThemeService";

export const useCoreDataLoader = (noFirstLoad = false) => {
  const dispatch = useDispatch();

  const storeUser = useSelector(selectUser);
  const storeForms = useSelector(selectUser)

  const [members, setMembers] = useState<User[]>([]);

  useEffect(() => {
    if (storeUser && !noFirstLoad) {
      (async () => {
        await loadAll(storeUser.currentWorkspaceId);
      })();
    }
  }, []);

  useEffect(() => {
    if (storeUser && !noFirstLoad) {
      (async () => {
        await loadAll(storeUser.currentWorkspaceId);
      })();
    }
  }, [storeUser]);

  const loadAll = async (workspaceId: string | undefined) => {
    if (!storeUser || !workspaceId) {
      return;
    }

    const useWorkspaceId = workspaceId
      ? workspaceId
      : storeUser.currentWorkspaceId;

    // get forms
    const forms = await apiGetEditableFormsForWorkspace(useWorkspaceId || "");
    // dispatch(setForms(forms));
    dispatch(setForms(forms?.sort((a: Form, b: Form) => a.name.localeCompare(b.name)) || []));

    // get tags
    const tags = await apiGetTagsForWorkspace(useWorkspaceId || "");
    dispatch(setTags(tags));

    // get themes
    const themes = await apiGetFormThemesForWorkspace(useWorkspaceId || "");
    dispatch(setFormThemes(themes));
    
  };

  const reloadAll = (workspaceId: string | undefined) => {
    (async () => {
      loadAll(workspaceId);
    })();
  };

  return { members, reloadAll };
};
